<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
    />
    <div
      :class="elementClasses(classes('classes'))"
    >
      <div
        :class="elementClasses(classes('containerClasses'))"
        :style="elementStyles(styles('containerStyles'))"
      >
        <div
          :class="elementClasses(classes('counterClasses'))"
          :style="elementStyles(styles('counterStyles'))"
        >
          <span v-if="content.hasPrefix">{{ content.prefix }}</span>
          <span>{{ counterElement }}</span>
          <span v-if="content.hasSuffix">{{ content.suffix }}</span>
        </div>
        <div
          v-if="content.hasTitle"
          :class="elementClasses(classes('titleClasses'))"
          :style="elementStyles(styles('titleStyles'))"
        >{{ content.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    computed: {
      counterElement() {
        return this.content.counter;
      }
    }
  })
</script>
